import setup from "./setup"

const getIsSDKTrackings = () =>
  JSON.parse(localStorage.getItem("@mobi/analytics"))?.isSDKTrackings

const track = (payload) => {
  const isSDKTrackings = getIsSDKTrackings()
  return setup({ isSDKTrackings }).then((_) => {
    if (isSDKTrackings) {
      window.TrackAnalytics.Track({ analytics: payload })
    } else {
      window.analyticsData = payload
      window._frameworkDA.Track()
    }
    console.log("%c @analytics/ga - track", "color: red", payload)
  })
}

const page = (payload) => {
  const isSDKTrackings = getIsSDKTrackings()
  return setup({ isSDKTrackings }).then((_) => {
    if (isSDKTrackings) {
      window.TrackAnalytics.Track({ analytics: payload })
    } else {
      window.analyticsData = payload
      window._frameworkDA.Track()
    }
    console.log("%c @analytics/ga - page view", "color: red", payload)
  })
}

export default {
  track,
  page,
}
